import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=302ce834"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302ce834')) {
      api.createRecord('302ce834', component.options)
    } else {
      api.reload('302ce834', component.options)
    }
    module.hot.accept("./CompanyView.vue?vue&type=template&id=302ce834", function () {
      api.rerender('302ce834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/CompanyView.vue"
export default component.exports